import moment from "moment";
moment.locale("pt-BR");

export default function formatDate(date, format = "") {
  return date ? moment(date).format(format) : "";
}

export const fromNow = (date) => moment(date).fromNow();
